var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { LinkTypes } from './link-types';
var Link = function (_a) {
    var children = _a.children, href = _a.href, _b = _a.type, type = _b === void 0 ? LinkTypes.REGULAR : _b, _c = _a.target, target = _c === void 0 ? '_blank' : _c;
    return (React.createElement("a", __assign({ className: 'link', target: target, href: href, "data-type": type }, (target === '_blank' && { rel: 'noreferrer' })), children));
};
export default Link;
